import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function SupabaseCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase's detectSessionInUrl exchanges the ?code / #hash on load.
    // Once a session exists (or auth resolves), send the user to the map.
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) navigate('/', { replace: true });
    });
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) navigate('/', { replace: true });
    });
    const t = setTimeout(() => navigate('/', { replace: true }), 4000);
    return () => { clearTimeout(t); sub?.subscription?.unsubscribe(); };
  }, [navigate]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-brand-paper" data-testid="supabase-callback">
      <div className="font-display text-2xl text-brand-ink">Signing you in…</div>
    </div>
  );
}
